import { SvgIcon, type SvgIconProps } from './svgIcon'

export const CopyIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19 5V14.625H9.375V5H19ZM8.5 9.375V11.125H6.75V17.25H12.875V15.5H14.625V19H5V9.375H8.5Z"
      fill="currentColor"
    />
  </SvgIcon>
)
